import { ReactNode } from 'react';

import { Button } from '@/components/atoms/new-button';

interface PopoverButtonProps {
  icon?: ReactNode;
  children: ReactNode;
  onClick?: () => void;
  asChild?: boolean;
}

export function PopoverButton({ icon, children, onClick, asChild = false }: PopoverButtonProps) {
  return (
    <Button
      size="sm"
      className="flex h-8 justify-start rounded-none bg-gray-800 text-white hover:bg-gray-700"
      onClick={onClick}
      asChild={asChild}
    >
      {asChild ? (
        children
      ) : (
        <>
          {icon}
          <span>{children}</span>
        </>
      )}
    </Button>
  );
}
